import React, { FC } from "react";
import { useParams } from "react-router-dom";
import { FooterContainer } from "../modules/footer/footer.container";
import { HeaderGenericContainer } from "../modules/header-generic/header-generic.container";
import { SearchBarContainer } from "../components/SearchBar/SearchBar.container";
import { OpenDataContainer } from "../modules/openData/openData.container";
import { LoginAreaContainer } from "../modules/login-area/login-area.container";
import { OpenDataFormContainer } from "../modules/openData/openDataForm.container";

export const OpenData: FC = () => {
  const { resources } = useParams<{ resources: string }>();

  const isFormRoute =
    resources === "despesa" ||
    resources === "servidor" ||
    resources === "usuarios";

  return (
    <div>
      <HeaderGenericContainer
        centerElement={<SearchBarContainer />}
        rightElement={<LoginAreaContainer variant="blue" />}
      />
      {isFormRoute ? <OpenDataFormContainer /> : <OpenDataContainer />}
      <FooterContainer />
    </div>
  );
};
